import { Module } from 'cerebral'
import showBasket from './chains/showBasket'
import setUnit from './chains/setUnit'
import setTargetOnBasket from './chains/setTargetOnBasket'
import setTarget from './chains/setTarget'
import deleteFromBasket from './chains/deleteFromBasket'
import clearBasket from './chains/clearBasket'
import setSize from './chains/setSize'
import onSaveSize from './chains/onSaveSize'
import sendOrder from './chains/sendOrder'
import setMessage from './chains/setMessage'
import onBeforeAddToBasket from './chains/onBeforeAddToBasket'
import addToBasket from './chains/addToBasket'

export default Module(({ name, path, controller }) => {
  return {
    state: {
      basketItems: {},
      orderId: null,
      unit: 'mm',
      message: {
        value: ''
      },
      receivers: {
        form: {
          value: '',
          isRequired: true,
          validationRules: ['isEmail']
        },
        tags: {}
      }
    },
    signals: {
      showBasket,
      setUnit,
      setTargetOnBasket,
      setTarget,
      deleteFromBasket,
      clearBasket,
      setSize,
      onSaveSize,
      sendOrder,
      setMessage,
      onBeforeAddToBasket,
      addToBasket
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/Basket/index.js